import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { getCurrentUser, fetchAuthSession, signOut } from "aws-amplify/auth";

@Injectable({
  providedIn: "root",
})
export class SessionService {
  constructor(private routes: Router) {}

  async isUserLoggedIn(): Promise<boolean> {
    const result = await this.getLoggedInUser();
    const isSignedIn =
      result?.session.tokens?.idToken?.toString() !== undefined;
    if (isSignedIn) {
      return true;
    } else {
      return false;
    }
  }

  async signOutUser() {
    await signOut();
    this.routes.navigate(["/authentication/login"]);
  }

  async getLoggedInUser() {
    let sess = null;
    try {
      const session = await fetchAuthSession();
      const { username, userId, signInDetails } = await getCurrentUser();
      sess = {
        session: session,
        username: username,
        userId: userId,
        signInDetails: signInDetails,
      };
    } catch (ex) {}
    return sess;
  }
  async getToken() {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString();
  }
}
